// import ga from 'react-ga';
import merge from 'lodash/merge';
import difference from 'lodash/difference';

import api from '~/utils/api';
import getCurrentCountrySite from '~/utils/region-site-config';
import { analytics as searchAnalytics } from '~/redux/reducers/search';
import { analytics as tripAnalytics } from '~/redux/reducers/trip';
import { analytics as sessionAnalytics } from '~/redux/reducers/session';
import { analytics as popupAnalytics } from '~/redux/reducers/popup';
import { analytics as toastAnalytics } from '~/redux/reducers/toast';
import { analytics as filterAnalytics } from '~/redux/reducers/filter';
import { analytics as cityAnalytics } from '~/redux/reducers/city';
import { analytics as homeAnalytics } from '~/redux/reducers/home';
import { analytics as appAnalytics } from '~/redux/reducers/app';

const events = [
  searchAnalytics,
  tripAnalytics,
  popupAnalytics,
  sessionAnalytics,
  toastAnalytics,
  filterAnalytics,
  cityAnalytics,
  homeAnalytics,
  appAnalytics
].reduce((a, b) => merge(a, b), {});

export default ({ getState }) => next => action => {
  const defaultProviders = ['database', 'googleAnalytics'];
  let providers = defaultProviders;
  const eventCreator = events[action.type];
  const isServer = !__CLIENT__;
  if (!eventCreator || isServer) {
    return next(action);
  }
  const event = eventCreator(action, getState);
  if (!event) {
    return next(action);
  }
  if (event.providers) {
    providers = event.providers.split(' ');
    const markRemoved = providers.map(provider => provider.replace(/[+-]/, ''));
    if (providers.every(provider => /^-/.test(provider))) {
      providers = difference(defaultProviders, markRemoved);
    } else {
      providers = markRemoved;
    }
  }
  // if (providers.indexOf('googleAnalytics') >= 0) {
  //   if (event.loggedIn) {
  //     ga.set({ userId: action.userId });
  //   }
  //   if (event.loggedOut) {
  //     ga.set({ userId: null });
  //   }
  //   if (event.path) {
  //     ga.pageview(event.path);
  //   } else {
  //     ga.event({
  //       category: event.category,
  //       action: event.name,
  //       value: event.value,
  //     });
  //     if (event.virtualPath) {
  //       ga.pageview(event.virtualPath);
  //     }
  //   }
  // }
  if (providers.indexOf('database') >= 0) {
    event.path = window && window.location && window.location.pathname; // handle server-side
    window.requestIdleCallback(() => {
      api.post('/logs', {
        namespace: event.category,
        title: event.name,
        // data: event
        data: {
          ...event,
          origin: `experience${getCurrentCountrySite() === 'EN' ? '' : `-${getCurrentCountrySite()}`}`,
          session_id: getState().session.id,
        },
      });
    });
  }
  return next(action);
};
